module.exports = __webpack_public_path__ + "img/prisoner.png";